import { gql } from '@apollo/client';

export const SET_GAME_OT = gql`
  mutation SetGameOt($gameId: Int!, $ot: overtime_enum) {
    update_schedule_by_pk(pk_columns: { id: $gameId }, _set: { ot: $ot }) {
      id
    }
  }
`;
